import React from 'react';

// styles
import './Conclusion.css';

const Conclusion = () => {
  return (
    <footer className='footer' id='conclusion'>
      <h1 className="footer__title">Висновки</h1>
      <p className="footer__subtitle">
       В сучасному світі синтетичні волокна відіграють важливу роль у багатьох сферах, зокрема у побуті та промисловості. Ці штучно створені волокна мають ряд переваг, таких як міцність, легкість, стійкість до зношування та вологості, а також широкі можливості в дизайні. У побутовій сфері синтетичні волокна широко використовуються для виготовлення текстильних виробів, таких як одяг, постільна білизна, штори та покривала. Їх використання дозволяє отримати матеріали з різними властивостями, які відповідають вимогам споживачів. Наприклад, поліестер є одним з найпопулярніших синтетичних волокон, оскільки воно має високу міцність і довговічність, добре тримає колір та дозволяє створювати різноманітні текстурні ефекти.
      </p>
    </footer>
  );
}

export default Conclusion;
